"use client";

import type { Locale } from "@/app/components/LanguageSelector";
import { useLocaleContext } from "@/app/components/LocaleProvider";

/**
 * Reactive accessor for the user's locale (`en` | `es`).
 *
 * Reads from `LocaleProvider`'s Context, which is seeded server-side
 * from the `frenflow_locale` cookie via `getServerLocale()`. The first
 * client render therefore agrees with the SSR HTML — no flash from EN
 * to the user's actual locale ~750 ms after hydration, and no
 * hydration mismatch errors.
 *
 * The Provider also listens to `frenflow:locale-change` so every
 * consumer of this hook flips simultaneously when the user toggles
 * the header selector (preserves the previous reactive behaviour).
 */
export function useLocale(): Locale {
  return useLocaleContext();
}
